export default "__VITE_ASSET__e4899305__"